export const capitalizeWords = (str) =>
    str.replace(/\b\w/g, (char) => char.toUpperCase());

export const validatePassword = (password) => {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    return regex.test(password);
  };